import getMediaElement from 'editor/src/store/design/selector/getMediaElement';
import { getStructureIndexByElementUuid } from 'editor/src/store/design/selector/getStructureIndexByElementUuid';
import { MediaImage } from 'editor/src/store/design/types';
import type { ThunkDispatch } from 'editor/src/store/hooks';
import { RootState } from 'editor/src/store/index';

import applyToSelectedMediaTypeOperation from './applyToSelectedMediaTypeOperation';

/**
 * GAPI-61891: sets the soft edge width (mm) of every selected image element; 0 removes it.
 * Each image is compared on its own (a multi-selection can mix feathers); nothing is dispatched (no undo step) when
 * every selected image already has that feather.
 */
const applyImageFeatherToSelectionOperation =
  (feather: number, preventSavingState = false) =>
  (dispatch: ThunkDispatch, getState: () => RootState) => {
    const value = feather > 0 ? feather : undefined;
    const needsUpdate = (element: MediaImage) =>
      (element.feather && element.feather > 0 ? element.feather : undefined) !== value;

    const state = getState();
    const anyChange = state.editor.selectedElementUuids.some((uuid) => {
      const address = getStructureIndexByElementUuid(state.design.designData, uuid);
      const element = address ? getMediaElement(state, address) : undefined;
      return element?.type === 'image' && needsUpdate(element);
    });
    if (!anyChange) {
      return;
    }

    dispatch(
      applyToSelectedMediaTypeOperation(
        'image',
        function applyImageFeather(element: MediaImage): Partial<MediaImage> | undefined {
          return needsUpdate(element) ? { feather: value } : undefined;
        },
        preventSavingState,
      ),
    );
  };

export default applyImageFeatherToSelectionOperation;
